import CircularProgress from '@mui/material/CircularProgress';


import { Box, Title, useScreenSize } from 'common';
import { AboutUs, useAboutUs } from 'api/aboutUs';
import { useEffect, useState } from 'react';

import { useLanguage } from '../../context/LanguageContext'

export const PromoComponent = () => {
    const { isDesktopSize } = useScreenSize();
    const { language } = useLanguage();
    const [aboutUs, setAboutUs] = useState<AboutUs[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const { onGetAllAboutUs } = useAboutUs();

    useEffect(() => {
        (async () => {
            try {
                const result = await onGetAllAboutUs();
                if (result.success) {
                    setAboutUs(result.data)
                } else {
                    setError('Произошла ошибка при загрузке страницы');
                }
            } catch (error: any) {
                setError(error.message || 'Неизвестная ошибка');
            } finally {
                setLoading(false);
            }
        })();
    }, [onGetAllAboutUs]);


    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', paddingY: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    // Если возникла ошибка, покажем сообщение об ошибке
    if (error) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', paddingY: 4 }}>
                <Title variant="h6" sx={{ color: 'error.main' }}>
                    Произошла ошибка: {error}
                </Title>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                paddingY: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}
        >
            <Title
                variant={isDesktopSize ? 'h3' : 'h4'}
                sx={{ fontWeight: 900, color: '#af0000' }}
            >
                AlmaU Open Library
            </Title>

            {aboutUs.map((item) => (
                <Box key={item.id} sx={{ paddingTop: 2 }}>
                    <Title variant="subtitle1">
                        <div dangerouslySetInnerHTML={{
                            __html: language === 'en' ? item.description_small_en :
                                language === 'ru' ? item.description_small_ru :
                                    item.description_small_kz
                        }} />

                    </Title>
                </Box>
            ))}
        </Box>
    );
};

